export enum MeetingTypes {
  meeting = 0,
  webinar = 1,
}
